import { render, staticRenderFns } from "./PeerGroupRoleSelectorPills.vue?vue&type=template&id=fd24d2ae&scoped=true&"
import script from "./PeerGroupRoleSelectorPills.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupRoleSelectorPills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd24d2ae",
  null
  
)

export default component.exports